import { mapGetters, mapState } from 'vuex';

import formatterMixin from './formatterMixin';

const leadDetailMixin = {
  mixins: [formatterMixin],
  computed: {
    ...mapState({
      currentAdmin: (state) => state.admin.current,
      lead: (state) => state.leadDetail.lead,
      alert: (state) => state.leadDetail.alert,
      pastAlerts: (state) => state.leadDetail.pastAlerts,
      cycles: (state) => state.leadDetail.cycles,
      alertCycles: (state) => state.leadDetail.alertCycles,
      customer: (state) => state.leadDetail.customer,
      address: (state) => state.leadDetail.address,
      hvac: (state) => state.leadDetail.hvac,
      leakEventHistory: (state) => state.leadDetail.leakEventHistory,
      activeAlertList: (state) => state.leadDetail.activeAlertList,
      leakHourlyHistory: (state) => state.leadDetail.leakHourlyHistory,
      batteryStatus: (state) => state.leadDetail.batteryStatus,
      loading: (state) => state.leadDetail.loading,
      printMode: (state) => state.leadDetail.printMode,
      leakLocation: (state) => state.leadDetail.leakLocation,
      serviceRequest: (state) => state.leadDetail.serviceRequest,
    }),
    ...mapGetters([
      'sensorGraphData',
      'gaugeGraphData',
      'pastAlertsData',
      'otherAlertsData',
      'leadCycleData',
      'runtimeBarGraphData',
      'runtimeLineGraphData',
    ]),
  },
  methods: {
    openLeadDetail(leadId, alert) {
      const { category } = alert;
      if (category === 'Performance' || category === 'Leak') {
        window.open(`/lead/pdf/${leadId}`);
      } else {
        this.toggleActionModal(true, 'coming', leadId);
      }
    },
    leadAction(show, action, lead) {
      if (!show) {
        this.$store.dispatch('closeLeadActionModal');
      } else {
        const changes = [{
          field: 'showActionModal',
          value: show,
        }, {
          field: 'actionModalView',
          value: action,
        }];
        this.$store.dispatch('setCurrentLead', {
          lead,
        });
        this.$store.dispatch('changeLeadValues', changes);
      }
    },
  },
};

export default leadDetailMixin;
